import { useLayoutEffect, useState } from 'react';
import { useEffect } from 'react';
import locationIcon from '../../assets/location-permissions/location-icon.svg';

import SafariDesktopPopupBlockedIcon from '../../assets/popup-permission/safari-desktop-allow-popup.png';
import SafariMobilePopupBlockedIcon from '../../assets/popup-permission/safari-mobile-allow-popup.png';

import ChromeDesktopPopupBlockedIcon from '../../assets/popup-permission/chrome-desktop-popup-blocked.png';
import ChromeMobilePopupBlockedIcon from '../../assets/popup-permission/chrome-mobile-popup-blocked.png';

import OverlayComponenMandatoryStep from './overlay-componen-mandatory-step';
import withDashboardMenuLayout from '../../fibe-ui/layout/withDashboardMenuLayout';
import { useNavigate, useSearchParams } from 'react-router-dom';

// DOCS: https://stackoverflow.com/questions/74348235/permissions-request-for-window-open
// There is no way of doing this. The only thing you can do is asking your users to go edit the settings in their browser or, as Rory said by commenting your post, create your own within your website.

const detectAndGetBrowserName = () => {
  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = typeof window.opr !== 'undefined';
  const isIEedge = winNav.userAgent.indexOf('Edg') > -1;
  const isIOSChrome = winNav.userAgent.match('CriOS');
  const isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;
  if (isSafari) {
    console.log('[BROWSER] Safari Browser');
    return 'SAFARI';
  }
  if (isIOSChrome) {
    // is Google Chrome on IOS
    console.log('[BROWSER] Google Chrome on IOS');
    return 'CHROME';
  } else if (
    isChromium !== null &&
    typeof isChromium !== 'undefined' &&
    vendorName === 'Google Inc.' &&
    isOpera === false &&
    isIEedge === false
  ) {
    console.log('[BROWSER] Google Chrome');
    return 'CHROME';
  } else {
    console.log('[BROWSER] NOT Google Chrome');
    return '';
  }
  return '';
};

const PopupPermissionPopup = () => {
  const [popupBlockedImageToDisplay, setPopupBlockedImageToDisplay] = useState(
    SafariDesktopPopupBlockedIcon
  );
  const [statusMsg, setStatusMsg] = useState('');
  const [statusDes, setStatusDes] = useState('');

  const [queryParams, setQueryParams] = useSearchParams();
  const navigate = useNavigate();

  const [showPermissionPopup, setShowPermissionPopup] = useState(false);

  let innerWidth = window.innerWidth;

  useEffect(() => {
    function handleWidthChange() {
      const currentBrowser = detectAndGetBrowserName();
      innerWidth = window.innerWidth;
      if (currentBrowser === 'SAFARI') {
        setStatusMsg('Pop-up Permission Required');
        setStatusDes(
          "Disable the 'Block Pop-ups' button in settings to proceed further."
        );
      } else if (currentBrowser === 'CHROME') {
        setStatusMsg('Pop-up Permission Required');
        setStatusDes("Click on 'Allow' in the next pop-up to proceed further.");
      }
      if (innerWidth > 600) {
        if (currentBrowser === 'SAFARI') {
          setPopupBlockedImageToDisplay(SafariDesktopPopupBlockedIcon);
        } else if (currentBrowser === 'CHROME') {
          setPopupBlockedImageToDisplay(ChromeDesktopPopupBlockedIcon);
        }
      } else {
        if (currentBrowser === 'SAFARI') {
          setPopupBlockedImageToDisplay(SafariMobilePopupBlockedIcon);
        } else if (currentBrowser === 'CHROME') {
          setPopupBlockedImageToDisplay(ChromeMobilePopupBlockedIcon);
        }
      }
    }
    handleWidthChange();
    window.addEventListener('resize', () => {
      handleWidthChange();
    });
  }, []);

  const handlePopup = () => {
    // setShowPermissionPopup(true);

    let route = queryParams.get('redirectTo');
    if (!route) route = '/dashboard';
    navigate(route);
    window.location.reload();
  };

  return withDashboardMenuLayout({
    isLeftProgressBarPresent: false,
    childComponent: (
      <>
        <div className="w-full h-full flex flex-col justify-center items-center bg-[#FFFFFF] rounded-lg border-[1px] border-[#E6E6E6] text-[#434343] py-3 md:py-1">
          <div className="flex flex-col w-[80%] justify-center items-center border-b-[1px] border-[#E6E6E6] py-3 md:py-1">
            <img className="py-3 md:py-1" src={locationIcon} alt="" />
            <span className="text-xl font-semibold py-1 text-center">
              Allow popup opening permission
            </span>
            <span className="text-lg font-normal py-3 md:py-1 text-center">
              We need your new window popup permission to proceed further
            </span>
          </div>
          <div className="flex flex-col w-[80%] justify-center items-center">
            <span className="text-xl font-semibold py-3 md:py-1">
              {statusMsg}
            </span>
            <span className="text-lg font-normal py-3 md:py-1 text-center">
              {statusDes}
            </span>
            <img
              className="py-3 md:py-1 mobile:w-full"
              src={popupBlockedImageToDisplay}
              alt="location-image"
            />
          </div>
          <button
            className="mt-2 bg-accent text-white text-xm md:text-lg font-normal text-center w-[50%] md:w-80 p-3 rounded-lg"
            onClick={handlePopup}
          >
            {/* Allow popup permission */}
            Okay, got it
          </button>
        </div>
        {showPermissionPopup && <OverlayComponenMandatoryStep />}
      </>
    ),
  });
};

export default PopupPermissionPopup;
